export default {
      id: "vague_titres-usage",
      viewBox: "0 0 150 20",
      url: "../dist/images/" + "sprite.svg#vague_titres-usage",
      toString: function () {
        return this.url;
      }
    }